import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { api } from "../../../utils/Api";
import { omit } from "lodash";
import { useParams } from "react-router-dom";

let myModal = {};

const animatedComponents = makeAnimated();

const initial_value = [
  {
    title: "",
    gst: false,
    gst_percent: "",
    hsn: "",
    amount: "",
  },
];

export default function ModalOtherCharges(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [id_value, SerIdValue] = useState(useParams());
  const [save_data, SetSaveData] = useState(initial_value);
  const [read_only, SetReadOnly] = useState(false);
  const [view_data, SetViewData] = useState({});

  useEffect(() => {
    console.log("ModalOtherCharges On mount :", props);
    let myModal1 = document.getElementById("ModalOtherCharges");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      console.log("close_data :", close_data);
      SetReadOnly(false);
      SetSaveData([{
        title: "",
        gst: false,
        gst_percent: "",
        hsn: "",
        amount: "",
      }]);
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.open) {
      console.log("ModalOtherCharges On mount :", props);
      myModal = new bootstrap.Modal(
        document.getElementById("ModalOtherCharges"),
        {}
      );
      if (props.type == "view") {
        SetViewData(props.data);
      }
      myModal.show();
    }
  }, [props.open]);

  async function add_other_charges() {
    console.log("create receipt :", save_data);

    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
      },
      post: { other_charges: save_data },
    };
    console.log("pass_data:", pass_data);
    let data = await api("/outlet/add_order_other_charges", pass_data);
    console.log("add_order_other_charges response :", data.response);
    if (data.status_code == 201) {
      let item = close_data;
      item.action = "save";
      item.value = data.response;
      console.log("Close data : ", item);
      SetCloseData(item);
      myModal.hide();
    }
  }

  return (
    <div
      className="modal fade"
      id="ModalOtherCharges"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title" id="ModalLabel">
              {props.type == "add" ? <h5>Add Other Charges</h5> : null}
              {props.type == "view" ? <h5>View Other Charges</h5> : null}
            </div>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>

          <div className="modal-body p-3">
            {props.type == "add" ? (
              <div className="mb-2">
                {save_data.map((ele: any, index: any) => (
                  <div className="p-2 pb-3" key={index}>
                    <fieldset className="rounded">
                      <legend>
                        <span
                          className="bg-white cursor px-3"
                          onClick={() => {
                            SetSaveData((prevValue) => {
                              prevValue.splice(index, 1);
                              return [...prevValue];
                            });
                          }}
                        >
                          <span className="text-red">
                            <img src={require("../../../assets/icon/svg/x2.svg")} className="action_menu_img pe-1 me-1" />
                            Remove

                          </span>
                        </span>
                      </legend>

                      <div className="row p-3 pt-0" key={index}>
                        {/* Title */}
                        <div className="col-md-3 col-6 mb-2">
                          <label className="form-label">Title</label>
                          <input
                            type="text"
                            className="form-control"
                            required
                            value={ele.title}
                            onChange={(e) => {
                              SetSaveData((prevValue) => {
                                prevValue[index].title = e.target.value;
                                return [...prevValue];
                              });
                            }}
                          />
                        </div>
                        {/* Amount */}
                        <div className="col-md-3 col-6 mb-2">
                          <label className="form-label">Amount</label>
                          <input
                            type="number"
                            className="form-control"
                            required
                            value={ele.amount}
                            onChange={(e) => {
                              SetSaveData((prevValue) => {
                                prevValue[index].amount = e.target.value;
                                return [...prevValue];
                              });
                            }}
                          />
                        </div>
                        {/* GST */}
                        <div className="col-md-3 col-6 mb-2">
                          <label className=" form-label d-flex mb-1">
                            <input
                              type="checkbox"
                              className="form-check me-2"
                              required
                              checked={ele.gst}
                              onChange={(e) => {
                                SetSaveData((prevValue) => {
                                  prevValue[index].gst = !prevValue[index].gst;
                                  return [...prevValue];
                                });
                              }}
                            />
                            GST
                          </label>
                          {ele.gst ? (
                            <div className="input-group">
                              <input
                                type="number"
                                className="form-control"
                                required
                                value={ele.gst_percent}
                                onChange={(e) => {
                                  SetSaveData((prevValue) => {
                                    prevValue[index].gst_percent =
                                      e.target.value;
                                    return [...prevValue];
                                  });
                                }}
                              />
                              <div className="input-group-append">
                                <span className="input-group-text">
                                  %
                                  {/* <i className="fas fa-percent fs-8 " /> */}
                                </span>
                              </div>
                            </div>
                          ) : null}
                        </div>
                        {/* Gst % */}

                        {/* Hsn */}
                        <div className="col-md-3 col-6 mb-2">
                          <label className="form-label">HSN</label>
                          <input
                            type="text"
                            className="form-control"
                            required
                            value={ele.hsn}
                            onChange={(e) => {
                              SetSaveData((prevValue) => {
                                prevValue[index].hsn = e.target.value;
                                return [...prevValue];
                              });
                            }}
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                ))}
              </div>
            ) : null}
            {props.type == "view" ? (
              <div>
                <div className="d-flex">
                  <p className="text-dark fs-6">{view_data.title}</p>
                  <small className="ms-auto">{view_data.created_at}</small>
                </div>
                <div>
                  <h6 className="fs-6">{view_data.created_user}</h6>
                  <p className="v-small fs-7">@{view_data.created_username}</p>
                </div>
                <div className="d-flex">
                  <p>HSN :{view_data.hsn}</p>
                  <p className="ms-auto">Amount : ₹{view_data.amount}</p>
                </div>
                <div className="d-flex">
                  <p>GST % :{view_data.gst_percent} </p>
                  <p className="ms-auto">
                    GST Amount : ₹{view_data.gst_amount}
                  </p>
                </div>
                <div className="d-flex">
                  {view_data.invoiced ? <p>Invoiced</p> : null}
                  <h6 className="ms-auto fs-6">
                    Total Amount : ₹{view_data.total_amount}
                  </h6>
                </div>
              </div>
            ) : null}
          </div>
          <div className="modal-footer">
            <div
            className="me-auto"
            >
              <button className="btn-light-outline btn" 
                onClick={() => {
                  console.log("Add Charges");
                  SetSaveData((prevValue) => {
                    let newValue = {
                      title: "",
                      gst: false,
                      gst_percent: "",
                      hsn: "",
                      amount: "",
                    };
                    prevValue.unshift(newValue);
                    return [...prevValue];
                  });
                }}>
                <img
                  src={require("../../../assets/icon/svg/plus1.svg")}
                  className="action_menu_img"
                />Add
              </button>
            </div>
            <button
              type="button"
              className="btn btn-light-outline"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            >
              Close
            </button>
            {props.type == "add" ? (
              <button
                type="button"
                className="btn btn-light-outline"
                onClick={() => {
                  add_other_charges();
                  console.log("save :", save_data);
                }}
              >
                Save
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
